import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const FloatingContact = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hero = document.querySelector("#hero");
    if (!hero) return;
    const observer = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { rootMargin: "-10% 0px 0px 0px" }
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          data-testid="floating-contact-button"
          onClick={() => scrollTo("#kontakt")}
          initial={{ opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 16, scale: 0.9 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="fixed bottom-6 right-5 z-40 flex items-center gap-2 rounded-full bg-[#4A7055] py-3.5 pl-4 pr-5 text-sm font-semibold text-[#F9F7F3] shadow-xl shadow-black/20 transition-all hover:-translate-y-0.5 hover:bg-[#3d5c47] md:bottom-8 md:right-8"
        >
          <CalendarCheck className="h-4 w-4" />
          Rezerwuj
        </motion.button>
      )}
    </AnimatePresence>
  );
};
